import { API_BASE_URL } from './index';

/**
 * Reset the socket throttling state on the server
 * 
 * Used between performance test runs to ensure consistent baseline conditions.
 * This function calls the server API to clear the throttling state, which prevents
 * throttling from previous tests affecting the results of subsequent tests.
 * 
 * @returns Promise that resolves with the server response
 */
export async function resetSocketThrottling(): Promise<{ message: string }> {
  const url = `${API_BASE_URL}/api/performance/throttling/reset`;
  
  try {
    // Post request to reset throttling state
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`Error resetting throttling: Server returned ${response.status}`, errorText);
      throw new Error(`Server returned ${response.status}: ${response.statusText}`);
    }
    
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error resetting socket throttling:', error);
    throw error;
  }
} 